export function stockLandingRoute(roles, activeRole) {
    const names = Array.isArray(roles) ? roles.map(role => role.nom) : []
    if (activeRole && activeRole.nom) {
        return activeRole.nom === 'ROLE_RESPONSABLE_LOGISTIQUE' ? '/espaces' : '/medicaments'
    }
    return names.includes('ROLE_RESPONSABLE_LOGISTIQUE') ? '/espaces' : '/medicaments'
}
